import React from 'react';
import styles from 'assets/css/Card.module.css';
import {LMSCourseCardComponent} from "../Components/LMSCourseCardComponent";

function PracticeTestsCard(props) {
    //local var(s)
    const { Tests: tests }  = props.data;

    //render
    return (
        <div className={styles.cardBodyDefault}>
            <div className="tests-container">
                {tests.map(test => (<LMSCourseCardComponent course={test} />))}
            </div>
        </div>
    )
}

export default PracticeTestsCard;
